<template>
    <a
        v-if="visible"
        class="w-full p-2 min-h-10 bg-yellow-500 text-black flex justify-center items-center gap-1 underline"
        @click="reload"
    >
        {{ $t("layouts.update-available.message") }}
    </a>
</template>

<script lang="ts" setup>
const { $listen } = useNuxtApp();
const visible = ref(false);

$listen("app:update-available", () => {
    visible.value = true;
});

const reload = () => {
    window.location.reload();
};
</script>
